import moment from 'moment/moment';
import {ICommonUtilInterface} from '../common/common-util.interface';
import {EMediaTranscodingItemStatus, TranscodingItem} from './transcoding-item';

export class ContentControlTranscodingItem extends TranscodingItem {

  constructor(
    public id: string,
    public contentControlItemUid: string,
    public videoTitle: string,
    public videoTenantUniqueId: string,
    public videoDurationMs: number,
    public startTimeMs: number,
    public endTimeMs: number,
    public status: EMediaTranscodingItemStatus,
    public statusesLogs: string,
    public lastStatusTime: moment.Moment,
    public resultUrl: string,
  ) {
    super(id, videoTitle, videoTenantUniqueId, videoDurationMs, startTimeMs, endTimeMs, status, statusesLogs, lastStatusTime, resultUrl);
  }

  public clone(utils: ICommonUtilInterface): TranscodingItem {
    return new ContentControlTranscodingItem(
      utils.generateGuid(),
      this.contentControlItemUid,
      this.videoTitle,
      this.videoTenantUniqueId,
      this.videoDurationMs,
      this.startTimeMs,
      this.endTimeMs,
      EMediaTranscodingItemStatus.Pending,
      '',
      null,
      '',
    );
  }

  public asRequest(): {} {
    return {
      Id: this.id,
      ContentControlItemUid: this.contentControlItemUid,
      StartTimeMs: this.startTimeMs,
      EndTimeMs: this.endTimeMs,
    };
  }
}
